import { SwitchVerticalIcon } from "@heroicons/react/outline";
import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";

type UploaderButtonProps = {
  onUpload: any;
  isUploading: any;
  acceptFiles: string;
  title: string;
};

export default function UploaderButton({
  onUpload,
  isUploading,
  acceptFiles,
  title,
}: UploaderButtonProps) {
  const [file, setFile] = useState<any>(null);
  const LocalBasePath = "page.alert";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  //   TO USE FOR TRANSLATION:  {t(`${LocalBasePath}.`)} replace your key after dot
  const onDrop = useCallback(async (acceptedFiles) => {
    isUploading(true);
    setFile(acceptedFiles[0]);
    await onUpload(acceptedFiles[0]);
  }, []);
  const onDropRejected = useCallback(async (acceptedFiles) => {
    isUploading(false);
  }, []);

  const { getRootProps, getInputProps, isDragReject, fileRejections } =
    useDropzone({
      onDrop,
      onDropRejected,
      accept: acceptFiles,
      maxSize: 5242880,
    });

  return (
    <div className="col-span-3">
      <button
        {...getRootProps({ className: "dropzone" })}
        type="button"
        className="inline-flex  mt-2  w-full items-center gap-2 justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500  sm:mt-0  sm:w-44"
      >
        <SwitchVerticalIcon className="w-5 text-gray-500" />
        {title}
        <input {...getInputProps()} />
      </button>
      {isDragReject && (
        <p className="mt-2 text-sm text-red-600">
          {t(`${LocalBasePath}.errorFile`)}
        </p>
      )}
      {fileRejections.length > 0 && (
        <p className="mt-2 text-sm text-red-600">
          {t(`${LocalBasePath}.errorSizeFile`, { size: 5 })}
        </p>
      )}
    </div>
  );
}
